module.exports = __webpack_public_path__ + "static/media/4.d148a0fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobileOmBoarding/4.png
// module id = 933
// module chunks = 21